import getLocalTimeZone from "utils/getLocalTimeZone";
/** default timezone */
export const DEFAULT_TIMEZONE = getLocalTimeZone();
